import { useAppDispatch, useAppSelector } from "app/hooks"
import { deleteFavoriteMeal } from "../favoriteMealsSlice"
import { useFailed, useSuccess } from "features/notification/hooks"

const useDeleteFavoriteMeal = (callback?: () => void) => {
  const dispatch = useAppDispatch()

  const handleDeleteFavoriteMeal = (mealId: string) => {
    dispatch(deleteFavoriteMeal(mealId))
  }

  const deleteFavoriteMealLoading = useAppSelector(
    (state) => state.favoriteMeals.deleteFavoriteMealLoading,
  )

  const deleteFavoriteMealSuccess = useAppSelector(
    (state) => state.favoriteMeals.deleteFavoriteMealSuccess,
  )

  const deleteFavoriteMealFailed = useAppSelector(
    (state) => state.favoriteMeals.deleteFavoriteMealFailed,
  )

  useSuccess(deleteFavoriteMealSuccess, { message: "" }, callback)

  useFailed(deleteFavoriteMealFailed)

  return {
    handleDeleteFavoriteMeal,
    deleteFavoriteMealLoading,
  }
}

export default useDeleteFavoriteMeal
